module.exports = __webpack_public_path__ + "img/arrow-right.304d0bf2.svg";